<template>
    <div class="header">
        <h1 class="header-title me-4">
            {{ $store.state.breadcrumbView.pageTitle }}
        </h1>
        <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li v-for="(item,index) in $store.state.breadcrumbView.path" :key="index"
                class="breadcrumb-item"
                :class="{'active':!item.to}"
            >
                <router-link v-if="item.to != undefined && item.to != null"
                    :to="item.to"
                >{{ item.name }}</router-link>
                <span v-else>{{ item.name }}</span>
            </li>
        </ol>
        </nav>
    </div>
</template>
<script>

export default {
    name:'breadcrumbView',
    components: {
        
    }
};
</script>
<style scoped>
.header{
    display: flex;
    align-items: baseline;
    margin-bottom: 0.25rem !important;
}
@media screen and (max-width: 767px) {
    .header{
        display: flex;
        flex-direction: column;
    }
    .breadcrumb{
        margin-bottom: .25rem;
    }
    .header-title{
        font-size: 1.525rem;
    }
}
</style>